'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgExchange = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.33 14.34a.347.347 0 0 0-.33-.33H6.67v-2a.347.347 0 0 0-.33-.33.34.34 0 0 0-.24.09L2.77 15.1a.34.34 0 0 0-.09.24c0 .09.03.17.09.23l3.32 3.33c.07.06.16.1.25.1.18-.01.32-.15.33-.33v-2H21c.18-.01.32-.15.33-.33v-2zm0-5.66a.34.34 0 0 0-.09-.24l-3.33-3.32a.407.407 0 0 0-.25-.11.314.314 0 0 0-.33.3v2.02H3c-.18.01-.33.16-.33.34v2c0 .18.15.33.33.34h14.33v2c.01.18.15.32.33.33.09 0 .18-.03.24-.09l3.33-3.33a.34.34 0 0 0 .09-.24h.01z",
  fill: "currentColor",
  vectorEffect: "non-scaling-stroke"
})));

exports["default"] = SvgExchange;
